import { isDevelopmentEnvironment } from "@/lib/env";

// Cupom por itens/produtos (bonificação de unidades do perfil do cliente no ciclo), no lugar do desconto por
// valor/percentual. Ligado: só aparece fora de produção. Desligue (false) para liberar em produção.
// Mantenha em sincronia com Features/CouponItemsFeature.cs do backend.
export const COUPON_ITEMS_DEV_ONLY = false;

export let isCouponItemsEnabled = false;

// Comente a linha abaixo para desativar o cupom por itens no frontend.
isCouponItemsEnabled = !COUPON_ITEMS_DEV_ONLY || isDevelopmentEnvironment;

// Apresentação do item de cupom no PDF do pedido: quando ligado, o item aparece em UMA linha (quantidade total,
// Valor unitário do cliente e total já com o desconto), sem destacar como bonificado/nota separada.
// Desligue (false) para voltar a listar o item do cupom em linha separada. Isolado de propósito (ver
// src/lib/couponItems.ts).
export const COUPON_ITEM_DISCOUNT_AS_VALUE = true;
